import React, { useEffect, useState } from 'react';
import Loader from '../../../../Constant/Custom/Loader';
import { Doughnut } from 'react-chartjs-2';
import { serverUrl } from '../../../../Constant/Static/config';
import axios from 'axios';

function CollegeStatus() {
    const [loading, setLoading] = useState(true);
    const [csrfToken, setCsrfToken] = useState('');
    const [submittedCount, setSubmittedCount] = useState(0);
    const [notSubmittedCount, setNotSubmittedCount] = useState(0);

    useEffect(() => {
        const fetchCsrfToken = async () => {
            try {
                const response = await axios.get(`${serverUrl}/api/csrf-token`, {
                    withCredentials: true
                });
                setCsrfToken(response.data.csrfToken);
            } catch (error) {
                console.error('Error fetching CSRF token:', error);
            }
        };

        fetchCsrfToken();
    }, []);

    useEffect(() => {
        const fetchUserData = async () => {
            if (csrfToken) {
                try {
                    const response = await axios.post(
                        `${serverUrl}/api/admin/stats/submitted`,
                        {},
                        {
                            headers: {
                                'CSRF-Token': csrfToken
                            },
                            withCredentials: true
                        }
                    );
                    // // console.log(response);
                    if (response.status === 200) {
                        const { submitted, total } = response.data.statsData;
                        setSubmittedCount(submitted);
                        setNotSubmittedCount(total);
                    } else {
                        // console.log('Error fetching data');
                    }
                } catch (error) {
                    console.error('Error fetching user data:', error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchUserData();
    }, [csrfToken]);


    const data = {
        labels: ['Submitted', 'Paid or Not Submitted'],
        datasets: [
            {
                label: 'Applications Status',
                data: [submittedCount, notSubmittedCount],
                backgroundColor: ['#36A2EB', '#FF6384'], // Colors for the donut chart
                hoverBackgroundColor: ['#36A2EB', '#FF6384'],
            },
        ],
    };

    const options = {
        responsive: true,
        plugins: {
            legend: {
                position: 'bottom',
            },
            tooltip: {
                callbacks: {
                    label: function (tooltipItem) {
                        const label = data.labels[tooltipItem.dataIndex];
                        const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.dataIndex];
                        return `${label}: ${value}`;
                    },
                },
            },
        },
    };

    if (loading) {
        return <Loader />;
    }

    return (
        <div className='chart-sub-container'>
            <h4>Application Submission Status</h4>
            <Doughnut data={data} options={options} />
        </div>
    );
}

export default CollegeStatus;